export enum ImportFileStatusEnum {
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  CREATED_SUCCESS = 'CREATED_SUCCESS',
  CREATED_WARNINGS = 'CREATED_WARNINGS',
  NOT_CREATED = 'NOT_CREATED',
  PROCESSING_FAILED = 'PROCESSING_FAILED',
  CREATED_PARTIALLY = 'CREATED_PARTIALLY',
  PROCESSING_PAUSED = 'PROCESSING_PAUSED',
  IMPOSSIBLE_TO_CORRECT = 'IMPOSSIBLE_TO_CORRECT',
}
